module.exports = __webpack_public_path__ + "static/media/parking_sconosciuto.8d288002.svg";